import { resources } from 'oems/resources';
import { Stack } from '@mui/material';
import MDBox from './MDBox';
import DataGridCell from './dataGridCell';
export function DocumentStatus(props) {
  var Icon = resources.NotPaidIcon;
  var text = 'Nieopłacona';
  if (props.paid) {
    Icon = resources.PaidIcon;
    text = 'Opłacona';
  }
  if (props.overdue) {
    Icon = resources.OverdueIcon;
    text = 'Po terminie';
  }
  return (
    <MDBox display="flex" justifyContent="center" alignItems="center">
      <Icon style={{ marginRight: 8 }} />
      <Stack>
        <DataGridCell justifyContent="center">{text}</DataGridCell>
      </Stack>
    </MDBox>
  );
}

export default DocumentStatus;
